import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import Layout from "./components/Layout";
import LoginPage from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import CompaniesPage from "./pages/Companies";
import CompanyDetail from "./pages/CompanyDetail";
import SyncRunsPage from "./pages/SyncRuns";
import VeriFactuPage from "./pages/VeriFactu";
import HoldedCompaniesPage from "./pages/HoldedCompanies";
import HoldedDetailPage from "./pages/HoldedDetail";
import ReviewQueuePage from "./pages/ReviewQueue";
import AuditPage from "./pages/Audit";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <div className="min-h-screen flex items-center justify-center text-ink-muted">Caricamento…</div>;
  if (user === null) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <div className="min-h-screen flex items-center justify-center text-ink-muted">Caricamento…</div>;
  if (user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
        <Route element={<Protected><Layout /></Protected>}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/companies" element={<CompaniesPage />} />
          <Route path="/companies/:id" element={<CompanyDetail />} />
          <Route path="/sync-runs" element={<SyncRunsPage />} />
          <Route path="/verifactu" element={<VeriFactuPage />} />
          <Route path="/holded" element={<HoldedCompaniesPage />} />
          <Route path="/holded/:companyId" element={<HoldedDetailPage />} />
          <Route path="/review" element={<ReviewQueuePage />} />
          <Route path="/audit" element={<AuditPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
